export const MessageTypes = {
    // Base networking: 0 - 19
    "server_connect": 0, // Not implemented
    "client_connect": 1, // Not implemented
    "client_message": 2, // Not implemented
    "server_message": 3, // Not implemented

    // Game logic: 20 - ?
    "AimAngle": 20,             // Vector2 -> x,y
    "AimAngleAndShoot": 21,     // Vector2 -> x,y

}